import { useCallback } from 'react';
import { uploadDatasetContribution } from './api';
import { prepareDatasetAudioSource } from './audioSource';

export function useDatasetContribution() {
  const contribute = useCallback(async (file, details = {}) => {
    const prepared = await prepareDatasetAudioSource(file);
    return uploadDatasetContribution(prepared.file, { ...details, ...prepared.details });
  }, []);

  return { contribute };
}
